import { select, all } from 'redux-saga/effects';
import { Config } from '@cian/config';
import { getConfig, getResults } from '../../selectors/commonSelectors';
import { getTotalPagesCount } from '../../utils/pagination';
import { IResultsState } from '../../common/state/app_state';

//@ts-ignore
export function* getTotalPages() {
  const [config, results]: [Config, IResultsState] = yield all([select(getConfig), select(getResults)]);

  const { aggregatedOffers } = results;

  const offersPerPage = Number(config.get('serp.offersPerPage'));

  return getTotalPagesCount(offersPerPage, aggregatedOffers);
}
